import Image from 'next/image';
import { Slot } from '../../../../../../../interfaces/interfaces';
import { formatUTCDate, imageKitLoader } from '../../../../../../../services/helper';
import PresentationTypeWithTooltip from '../PresentationTypeWithToopltip';

const PublicPresentationLeftContent = ({
  slot,
  presentationTextColor,
  showStartEndTime,
}: {
  slot: Slot;
  presentationTextColor: string;
  showStartEndTime?: boolean;
}) => {
  const showSlotTime = () => {
    if (showStartEndTime) return `${formatUTCDate(new Date(slot.datetime_start), 'HH:mm')} - ${formatUTCDate(new Date(slot.datetime_end), 'HH:mm')}`;
    return formatUTCDate(new Date(slot.datetime_start), 'HH:mm');
  };

  return (
    <>
      <div className="flex flex-col p-4 box__left max-w[90%] max-h-full overflow-y-auto">
        <div className="flex gap-2">
          {slot.meetingroom.image && (
            <div className="object-cover z-20 mb-2 w-16 h-16 rounded-full border border-white">
              <Image
                loader={imageKitLoader}
                className="w-full h-full rounded-full"
                objectFit="cover"
                src={slot.meetingroom.image}
                width={64}
                height={64}
                quality={80}
                alt="Speaker"
              />
            </div>
          )}
          <PresentationTypeWithTooltip slot={slot} className="text-white cursor-default" textColor={presentationTextColor} />
        </div>
        <div className="flex flex-col w-full content-holder">
          <span style={{ color: presentationTextColor }} className="w-full text-xs break-words">
            {slot.meetingroom.booth.name} {slot.meetingroom.contactperson && `${slot.meetingroom?.booth?.name ? '| ' : ''} ${slot.meetingroom.contactperson}`}
          </span>
          <p style={{ color: presentationTextColor }} className="w-full font-bold break-words">
            {slot.meetingroom.name}
          </p>
        </div>
        <div className="flex flex-col justify-end h-full">
          <span style={{ color: presentationTextColor }} className="text-xs">
            {showSlotTime()}
          </span>
        </div>
      </div>
    </>
  );
};

export default PublicPresentationLeftContent;
